import { createAsyncReducer } from "@telstra-connect/standard-actions/reducers";
import {
    ITrackIncidentsExportTicketAction,
    ITrackIncidentsExportTicketSuccessAction,
    ITrackIncidentsExportTicketErrorAction,
} from "../actions/track-incidents-export";
import { ITicketsState } from "../state";
import { initialState } from "./initial-state";

export type TrackIncidentsExportTicketAction =
    | ITrackIncidentsExportTicketAction
    | ITrackIncidentsExportTicketSuccessAction
    | ITrackIncidentsExportTicketErrorAction;

const init = (
    state: ITicketsState,
    action: TrackIncidentsExportTicketAction
) => ({
    ...state,
    trackIncidentsExport: {
        ...initialState.trackIncidentsExport,
        status: action.status,
    },
});

const success = (
    state: ITicketsState,
    action: TrackIncidentsExportTicketAction
) => ({
    ...state,
    trackIncidentsExport: {
        fileName: (action as ITrackIncidentsExportTicketSuccessAction).fileName,
        status: action.status,
    },
});

const failure = (
    state: ITicketsState,
    action: TrackIncidentsExportTicketAction
) => ({
    ...state,
    trackIncidentsExport: {
        status: action.status,
        error: (action as ITrackIncidentsExportTicketErrorAction).error,
    },
});

export const trackIncidentsExportReducer = createAsyncReducer(
    initialState,
    init,
    success,
    failure
);
